// Output layouts for the AD control track (WHP 198 audio description studio
// signal). `channels` lists what each output channel carries, in order.
export default [
    {
        id: "none",
        channels: [],
    },
    {
        // WHP 198 §2: description audio on the left channel, data on the right
        id: "ad-control-2ch",
        fileSuffix: "_AD_CONTROL",
        channels: ["ad", "control"],
    },
];
